module.exports = __webpack_public_path__ + "img/Personal Setting.7f03097c.svg";